export const isInvalidReEntryDaysUseCase = (value: number | null) => {
  const isFilled = value !== null
  const isPositive = Number(value) < 1
  return isFilled && isPositive
}
